var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-wrapper", class: _vm.classObj },
    [
      _c("topbar", { attrs: { name: _vm.name, unit: _vm.school_name } }),
      _vm._v(" "),
      _vm.device === "mobile" && _vm.sidebar.opened
        ? _c("div", {
            staticClass: "drawer-bg",
            on: { click: _vm.handleClickOutside },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("sidebar", { staticClass: "sidebar-container" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main-container" },
        [
          !_vm.role.includes("25")
            ? _c(
                "div",
                { staticClass: "page-title" },
                [
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.pagetitle == "首页",
                          expression: "pagetitle=='首页'",
                        },
                      ],
                    },
                    [_vm._v(_vm._s(_vm.name) + "，你好！欢迎使用资产管理系统~")]
                  ),
                  _vm._v(" "),
                  _c("breadcrumb", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.pagetitle != "首页",
                        expression: "pagetitle!='首页'",
                      },
                    ],
                    staticClass: "breadcrumb-container",
                    on: { levelList: _vm.isShowBreadcrumb },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("app-main"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }